import { Button } from '@/components/ui/button';
import { FcGoogle } from 'react-icons/fc';
import { Loader2 } from 'lucide-react';
import { useGoogleLogin } from '@/hooks/useGoogleLogin.hooks';
import { ApiTypes } from '@/types/server/api.types';

interface LoginButtonProps {
	setIsUserLoggedIn: (isUserLoggedIn: boolean) => void;
	redirectTo?: string;
	className?: string;
	children?: React.ReactNode;
	buttonText?: string;
	buttonVariant?: 'outline' | 'default';
	setUserDetails: (
		userDetails: ApiTypes.TGetCandidateDetailsResponse['data']
	) => void;
}

export const LoginButton = ({
	setIsUserLoggedIn,
	redirectTo = '/',
	className = '',
	children,
	buttonText = 'Continue with Google',
	buttonVariant = 'outline',
	setUserDetails,
}: LoginButtonProps) => {
	const { isLoading, initiateGoogleLogin, isGoogleAvailable } = useGoogleLogin({
		setIsUserLoggedIn,
		redirectTo,
		setUserDetails,
	});

	return (
		<Button
			disabled={isLoading || !isGoogleAvailable}
			variant={buttonVariant}
			className={`flex items-center justify-center gap-2 cursor-pointer ${className}`}
			onClick={initiateGoogleLogin}
		>
			{isLoading ? (
				<Loader2 className="h-4 w-4 animate-spin" />
			) : (
				<FcGoogle size={20} />
			)}
			{children || (isLoading ? 'Logging in...' : buttonText)}
		</Button>
	);
};
